/*
 * @Author: 冯杰
 * @Date: 2021-08-11 17:25:44
 * @LastEditTime: 2021-09-09 16:35:47
 * @FileName: 陈列图片
 */
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

import DisplayPhotos from './photo.vue';

formCreate.component('DisplayPhotos', DisplayPhotos);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submit: false,
        close: true,
        submitAudit: false,
      },
      formFunctionCode: 'photoForm',
    };
  },
  methods: {
    setRule(v) {
      const item = v;
      if (item.field === 'DisplayPhotos') {
        item.props = {
          ...item.props,
          code: this.formConfig.busCode,
        };
      }
      return item;
    },
    formComplete() {},
  },
};
